<!--suppress HtmlUnknownTag, HtmlUnknownAttribute, CssUnusedSymbol -->
<template>
    <div class="container-wrapper" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
         v-loading="$store.state.loadingCount>0"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-container class="main-container">
            <el-main style="height: 100%;width: 100%">
                <keep-alive>
                    <transition name="fade" mode="out-in">
                        <router-view style="height: 100%;overflow: auto"></router-view>
                    </transition>

                </keep-alive>
            </el-main>
        </el-container>
    </div>
</template>
<script>
export default {
    data() {
        return {
            ww: 0,
            wh: 0,
            tags: [],
            navs: {
                checkedNavItem: '',
                pages: [],
            },
        }
    },
    components: {},
    watch: {},
    methods: {
        navCheck(item) {
            let role = this.$store.state.loginUser.role
            if (this.$route.path !== '/' + role + '/' + item.route) {
                this.navs.checkedNavItem = item.route
                if (item.route === this.$route.path) return
                this.$router.push(item.route)
            }
        },
        logOut() {
            localStorage.removeItem('user')
            this.$store.commit('setUser', null)
            this.$router.replace('/')
        }
    },
    beforeMount() {
    },
    created() {
    },
    mounted() {
        let role = this.$store.state.loginUser.role
        setTimeout(() => {
            let path = '/' + role + '/' + this.$router.options.routes[1].children[0].path
            this.$router.push(path)
        }, 10)
        this.$router.options.routes[1].children.forEach(r => {
            if (r.meta.nav) {
                this.navs.pages.push({name: r.name, route: r.path})
            }
        })
        this.navs.checkedNavItem = this.navs.pages[0].route

        this.ww = document.body.clientWidth
        this.wh = document.body.clientHeight
        window.onresize = (() => {
            this.ww = document.body.clientWidth
            this.wh = document.body.clientHeight
        })
    }
}
</script>
<style>
.navItem {
    width: 200px;
    background-color: white;
    height: 100%;;
    display: flex;
    cursor: pointer;

    justify-content: center;
    align-items: center;
}

.navItem:hover {
    background-color: #0097f2;
    color: white;
}

.navItemChecked {
    background-color: #0097f2;
    color: white;
}

.quitSpan:hover {
    opacity: 0.6;
    cursor: pointer;
}

.quitSpan {
    font-size: 30px;
}
</style>